import { GET_SNACKBAR } from "../action/dataAction";

const initState = {
  snackbar: {
    open: false,
    content: "",
    severity: "success",
  },
};

const dataReducer = (state = initState, action) => {
  switch (action.type) {
    case GET_SNACKBAR:
      return {
        ...state,
        snackbar: action.payload.snackbar,
      };

    default:
      break;
  }

  return state;
};

export default dataReducer;
